import { render, staticRenderFns } from "./ProductDutyAddForm.vue?vue&type=template&id=1e1653b6&scoped=true&"
import script from "./ProductDutyAddForm.vue?vue&type=script&lang=ts&"
export * from "./ProductDutyAddForm.vue?vue&type=script&lang=ts&"
import style0 from "./ProductDutyAddForm.vue?vue&type=style&index=0&id=1e1653b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e1653b6",
  null
  
)

export default component.exports